export enum CompositionEventsEnum {
    LAYER_ADDED = "layer:added",
    CLIP_ADDED = "clip:added",
}